<template>
  <div class="login">
    <div class="left" v-if="value == 0">
      <div class="stitle">Bimmer Meta</div>
      <div class="btitle">welcome back!</div>
      <div class="fList">
        <p @click="value = 2">Tourist Mode</p>
        <p @click="value = 1">Go Register <img src="../assets/newImg/向右3.png" /></p>
      </div>

      <div class="box">
        <input placeholder="Please enter the account number" v-model="account" />
      </div>

      <div class="box">
        <input
          placeholder="Please enter the password"
          v-model="psw"
          show-password
          type="password"
        />
      </div>

      <div class="box box1" @click="login">LOGIN</div>
    </div>

    <div class="left" v-if="value == 1">
      <div class="stitle">Bimmer Meta</div>
      <div class="btitle">welcome back!</div>
      <div class="fList">
        <p @click="value = 2">Tourist Mode</p>
        <p @click="value = 0">Go Login <img src="../assets/newImg/向右3.png" /></p>
      </div>

      <div class="box">
        <input placeholder="Please enter the nickname" v-model="nickname" />
      </div>
      <div class="box">
        <input placeholder="Please enter the account number" v-model="raccount" />
      </div>

      <div class="box">
        <input placeholder="Please enter the password" v-model="rpsw" type="password" />
      </div>

      <div class="box">
        <input
          placeholder="Please enter the password agin"
          v-model="cpsw"
          type="password"
        />
      </div>

      <div class="box box1" @click="register">REGISTER</div>
    </div>

    <div class="left" v-if="value == 2">
      <div class="stitle">Bimmer Meta</div>
      <div class="btitle">welcome back!</div>
      <div class="fList">
        <p @click="value = 0">Go Login</p>
        <p @click="value = 1">Go Register</p>
      </div>

      <div class="box">
        <input placeholder="Please enter the nickname" v-model="nickname1" />
      </div>

      <div class="box box1" @click="login1">LOGIN</div>
    </div>
    <img src="../assets/newImg/banner.png" class="pic" />
    <img class="logo" src="../assets/newImg/logo.png" />
  </div>
</template>

<script>
import { register, login, mail_send, mail_verify, save } from "../assets/api/index";
import axios from "axios";
import md5 from "js-md5";
export default {
  data() {
    return {
      type: "",
      account: "",
      psw: "",
      nickname: "",
      nickname1: "",
      raccount: "",
      rpsw: "",
      cpsw: "",
      value: 0,
      // options: [
      //   {
      //     value: "zh",
      //     label: this.$t("info.lang.zh"),
      //   },
      //   {
      //     value: "en",
      //     label: this.$t("info.lang.en"),
      //   },
      // ],
      // lang: "zh",
      activeName: "login",
      vnum: "",
    };
  },
  methods: {
    reloadcode() {
      if (!this.email1 || !this.email2) {
        this.$message.error("请填写完整邮箱");
        return;
      }
      var email = `${this.email1}${this.email2}`;
      mail_send({ email }).then((res) => {
        this.$message(res);
        this.timmer = setInterval(() => {
          this.time--;
          this.msg = `还剩${this.time}s`;

          if (this.time == 0) {
            this.time = 30;
            clearInterval(this.timmer);
            this.msg = "获取邮箱验证码";
          }
        }, 1000);
      });
    },
    login() {
      console.log(axios.defaults.baseURL);
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.account || !this.psw) {
        this.$message.error(this.$t("info.lang.loginError1"));
      } else if (!reg.test(this.account)) {
        this.$message.error(this.$t("info.lang.loginError5"));
      } else {
        login({
          acount: this.account,
          psd: md5(this.psw),
        }).then((res) => {
          if (res.code != 1) {
            this.$message({
              message: this.$t("info.lang.loginSuccess"),
              type: "success",
            });
            var obj = {
              acount: this.account,
              psd: md5(this.psw),
            };
            localStorage.setItem("info", JSON.stringify(obj));

            this.$router.push({ name: "index" });
            document.o2.firstLogin = true;
          } else {
            this.$message.error(res.error);
          }
        });
      }
    },

    register() {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      var reg1 = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;

      console.log(this.raccount, this.rpsw);
      if (!this.raccount || !this.rpsw || !this.nickname || !this.cpsw) {
        this.$message.error(this.$t("info.lang.loginError1"));
      } else if (!reg.test(this.raccount)) {
        this.$message.error(this.$t("info.lang.loginError5"));
        // } else if (this.psw != "123456") {
        //   this.$message.error(this.$t("info.lang.loginError2"));
      } else if (this.cpsw != this.rpsw) {
        this.$message.error(this.$t("info.lang.passwordInfo2"));
      } else if (!reg1.test(this.nickname)) {
        this.$message.error("昵称不能包含特殊符号");
      } else {
        if (this.type == 1) {
          mail_verify({
            code: this.emailcode,
            email: `${this.email1}${this.email2}`,
          }).then((res) => {
            console.log(res);

            if (res == false) {
              this.$message.error("邮箱验证失败");
            } else {
              register({
                name: this.nickname,
                acount: this.raccount,
                psd: md5(this.rpsw),
              }).then((res) => {
                if (res.code == 0) {
                  save({
                    name: this.nickname,
                    info: JSON.stringify({
                      email: `${this.email1}${this.email2}`,
                      type: this.type,
                      name: this.nickname,
                      sex: 1,
                      accInfo: "0-0-0-1",
                      avatar: 0,
                      bodyColor: "#F66C47",
                      hairColor: "#191919",
                    }),
                    auth: 2,
                  }).then((res) => {
                    if (res.code == 0) {
                      this.account = this.raccount;
                      this.value = 0;
                    }
                  });
                  this.$message({
                    message: res.info,
                    type: "success",
                  });
                } else {
                  this.$message.error(res.info);
                }
              });
            }
          });
        } else {
          register({
            name: this.nickname,
            acount: this.raccount,
            psd: md5(this.rpsw),
          }).then((res) => {
            if (res.code == 0) {
              save({
                name: this.nickname,
                info: JSON.stringify({
                  email: this.email,
                  type: this.type,
                  name: this.nickname,
                  sex: 1,
                  accInfo: "0-0-0-1",
                  avatar: 0,
                  bodyColor: "#F66C47",
                  hairColor: "#191919",
                }),
                auth: 2,
              }).then((res) => {
                if (res.code == 0) {
                  this.account = this.raccount;
                  this.activeName = "login";
                }
              });

              this.$message({
                message: res.info,
                type: "success",
              });
            } else {
              this.$message.error(res.info);
            }
          });
        }
      }
    },

    login1() {
      var obj = {
        acount: this.num,
        psd: 123,
        type: true,
        name: this.nickname1,
      };

      localStorage.setItem("info", JSON.stringify(obj));
      this.$router.push({ name: "index" });
      document.o2.firstLogin = true;
    },

    getRandomSixNum() {
      let RandomSixStr = "";
      for (let i = 0; i < 6; i++) {
        RandomSixStr += String(Math.floor(Math.random() * 10));
      }
      return RandomSixStr;
    },
  },
  watch: {
    lang(val) {
      this.$i18n.locale = val;
      this.options[0].label = this.$t("info.lang.zh");
      this.options[1].label = this.$t("info.lang.en");
      localStorage.setItem("locale", val);
    },

    value(val) {
      if (val == 2) {
        this.vnum = this.getRandomSixNum();
        this.nickname1 = `游客${this.vnum}`;
      }
    },
  },

  beforeCreate() {
    console.log("加载开始");
    if (localStorage.getItem("info")) {
      this.$router.push({ name: "index" });
    }
  },

  created() {
    if (localStorage.getItem("locale")) {
      console.log(localStorage.getItem("locale"));
      this.lang = localStorage.getItem("locale");
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  color: #333333;
  font-family: BMW Group, BMW Group-Bold;

  .left {
    margin-left: 15%;
    width: 374px;
    transform: skew(30deg);
    height: 400px;
  }
  .stitle {
    font-size: 16px;
    font-weight: 700;
    text-align: left;

    margin-top: 300px;
    transform: skew(-30deg);
  }
  .btitle {
    font-size: 39px;
    font-weight: 700;
    text-align: left;
    transform: skew(-30deg);
  }
  .fList {
    display: flex;
    width: 374px;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #999;
    margin-top: 13px;
    transform: skew(-30deg);

    p {
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
      }
    }
    cursor: pointer;
  }
}
.pic {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.logo {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 425px;
  right: 130px;
  margin: auto;
}

.box {
  width: 374px;
  height: 52px;
  background: url("../assets/newImg/box.png");
  transform: skew(-30deg);
  margin-top: 20px;

  input {
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    text-align: left;
    color: #333333;
    height: 100%;
    border: 0;
    width: 80%;
    outline: none;
  }
}

.box2 {
  width: 374px;
  height: 52px;
  transform: skew(-30deg);
}

.box1 {
  background: url("../assets/newImg/box1.png");
  font-size: 18px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

@media screen and (max-width: 1500px) {
  .login .left {
    transform: skew(30deg) scale(0.75);
    margin-left: 20%;
    margin-top: -7%;
  }
  .logo {
    width: 300px;
    right: 60px;
  }

  .pic {
    height: 100%;
    width: auto;
  }
}

@media screen and (max-width: 500px) {
  .login {
    .info {
      width: 100%;
    }
    .pic {
      width: 0;
    }
  }
}
</style>
